<template>
<div class="chapter">
<div class="inner_page">
<div class="section level1" id="dedication">
<h1>Dedication</h1>
<p style="text-align: center;">Dedicated to Mom and Dad,</p>
<p style="text-align: center;">to mountaineers, wherever they live,</p>
<p style="text-align: center;">and to our servicemen who continue the battle for freedom.</p>
</div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// ch002.vue?0293c483